<template>
    <div>
        <fieldset aria-describedby="field-guide-area">
            <div class="search-components">
                <search-address
                    :label="searchAddressLabel"
                    :placeholder="searchAddressPlaceholder"
                />
                <locate-me />
            </div>
            <text-field
                :label="textFieldLabel"
                :placeholder="textFieldPlaceholder"
                class="search-field"
            />
            <bandwidth-field
                :label="bandwidthLabel"
                class="search-field"
            />
            <br>
        </fieldset>
    </div>
</template>

<script lang="ts">
    import { Component, Vue, Watch } from "vue-facing-decorator"
    import ApiService from "@/services/ApiService"
    import SearchAddress from "@/components/SearchAddress.vue"
    import LocateMeLink from "@/components/LocateMeLink.vue"
    import TextField from "@/components/TextField.vue"
    import RadiomikrofonitBandwidthField from "@/components/RadiomikrofonitBandwidthField.vue"
    import LocaleHelper from "@/helpers/localeHelper"
    import DynamicRightSlotData from "@/models/dynamicrighslotdata"
    import { store } from '@/store/store'

    @Component({
        components: {
            "locate-me": LocateMeLink,
            "search-address": SearchAddress,
            "text-field": TextField,
            "bandwidth-field": RadiomikrofonitBandwidthField
        }
    })
    export default class Radiomikrofonitaajuudet extends Vue {
        apiService: ApiService = new ApiService(store.getters.baseHref)
        apiCallBasePart: string = "v1/Radiomikrofonitaajuudet/"
        pageName: string = "Radiomikrofonitaajuudet"
        // koordinaatit
        coordX: string = ""
        coordY: string = ""

        async activated() {
            // Tyhjennetään kartta
            store.dispatch("setDataUrlToLoad", null)
            store.dispatch("setStopLocate")
            store.dispatch("setCurrentPage", this.pageName)
            store.dispatch("setLoading", { name: this.pageName, value: true })

            if (store.getters.frequencySearchData.lat !== "0" && store.getters.frequencySearchData.lng !== "0") {
                store.dispatch("setFrequencySearchData", { lat: "0", lng: "0", f1: "", f2: "", bw: "" })
            }

            store.dispatch("setRightSlotData", new DynamicRightSlotData(""))

            // Asetetaan oikean slotin sisältö
            store.dispatch("setRightSlot", this.pageName)

            await this.setDataToLoad()

            store.dispatch("setLoading", { name: this.pageName, value: false })
        }

        deactivated() {
            store.dispatch("setCurrentPage", "")
            store.dispatch("setSubTopic", null)
            store.dispatch("setSearchAddressSelected", null)
        }

        async setDataToLoad(): Promise<void> {
            this.updateData()
        }

        async updateData(): Promise<void> {
            store.dispatch("setLoading", { name: this.pageName, value: true })

            // Asetetaan oikean slotin sisältö
            // jos osoite, eli koordinaatit on saatu käyttäjältä, niin tehdään vapaiden taajuuksien haku
            if (store.getters.frequencySearchData.lat !== "0" && store.getters.frequencySearchData.lng !== "0") {
                store.dispatch("setDataUrlToLoad", {
                    url: this.apiCallBasePart + "Radiomikrofonitaajuudet"
                        + "?lat=" + store.getters.frequencySearchData.lat
                        + "&lng=" + store.getters.frequencySearchData.lng
                        + "&f1=" + ""
                        + "&f2=" + ""
                        + "&bw=" + "",
                    type: this.pageName,
                    clearLocationMarker: true
                })
            }
            store.dispatch("setLoading", { name: this.pageName, value: false })
        }

        // ladataan data uudestaan, koska kielivalinta on muuttunut
        @Watch("activeLang")
        async onActiveLang(): Promise<void> {
            if (this.currentPage !== this.pageName) {
                return
            }
            this.setDataToLoad()
        }

        get currentPage(): string {
            return store.getters.currentPage
        }

        // Osoitehaku
        get searchAddressSelected() {
            return store.getters.frequencySearchData
        }

        @Watch("searchAddressSelected")
        async onFrequencySearchSelected(): Promise<void> {
            if (this.searchAddressSelected) {
                this.coordX = this.searchAddressSelected.lat.toString()
                this.coordY = this.searchAddressSelected.lng.toString()
                await this.setDataToLoad()
            }
        }

        get leftSlotHeaderRadiomikrofonitaajuudet(): string | undefined {
            return this.$t("App.Header.Viestinta.Radiomikrofonitaajuudet")
        }

        get searchAddressLabel() {
            return this.$t("App.Radiomikrofonitaajuudet.SearchAddressLabel")
        }

        get searchAddressPlaceholder() {
            return this.$t("App.Radiomikrofonitaajuudet.SearchAddressPlaceholder")
        }

        get textFieldLabel() {
            return this.$t("App.Radiomikrofonitaajuudet.RadioFrequencyInputLabel")
        }

        get textFieldPlaceholder() {
            const minFrequency = LocaleHelper.formatDecimal(this.$store.getters.minMaxRadioMFrequencies.min.toFixed(2))
            const maxFrequency = LocaleHelper.formatDecimal(this.$store.getters.minMaxRadioMFrequencies.max.toFixed(2))

            const limits = minFrequency + " - " + maxFrequency

            return this.$t("App.Radiomikrofonitaajuudet.RadioFrequencyInput.Placeholder", [limits])
        }

        get bandwidthLabel() {
            return this.$t("App.Radiomikrofonitaajuudet.BandwidthInputLabel")
        }
    }
</script>
<style scoped>
    .dropdowns {
        margin-bottom: 2.5rem;
    }

    .search-field {
        margin-bottom: 1rem;
    }
</style>
